<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center" class="wrap">
  <app-account-image [account]="account"></app-account-image>
  <small matTooltip="{{ date | fsDateFormat }}"> {{ date | fsDateAgo: 'date-yearless' }}</small>
</div>
